export class ReturnDetailModel {
  id: number;
  fecha: Date;
  estado: string;
  monto: number;
  titulo: string;

  constructor(id: number, fecha: Date, estado: string, monto: string, titulo: string) {
    this.id = id;
    this.fecha = fecha;
    this.estado = estado;
    this.monto = parseFloat(monto);
    this.titulo = titulo;
  }
}
